import React from 'react'
import {Icon} from '@chakra-ui/react'

const CompareIcon = (props) => {
    return (
        <Icon viewBox="0 0 12 12" fill="none" {...props}>
            <g clipPath="url(#clip0_3643_25883)">
                <path
                    d="M7.95242 3.92154C7.67672 2.26381 6.23595 1 4.5 1C2.567 1 1 2.567 1 4.5C1 6.18943 2.19698 7.59928 3.78912 7.92776"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.5 11C9.433 11 11 9.433 11 7.5C11 5.567 9.433 4 7.5 4C5.567 4 4 5.567 4 7.5C4 9.433 5.567 11 7.5 11Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <line
                    opacity="0.2"
                    x1="6.25"
                    y1="4"
                    x2="6.25"
                    y2="11"
                    stroke="currentColor"
                    strokeWidth="1.5"
                />
                <line
                    opacity="0.2"
                    x1="8.75"
                    y1="4"
                    x2="8.75"
                    y2="11"
                    stroke="currentColor"
                    strokeWidth="1.5"
                />
            </g>
            <defs>
                <clipPath id="clip0_3643_25883">
                    <rect width="12" height="12" fill="white" />
                </clipPath>
            </defs>
        </Icon>
    )
}

export default CompareIcon
